
import LinkResolver from './LinkResolver.vue'

export default {
  components: { LinkResolver },
  props: {
    slide: {
      type: Object,
      required: true,
    },
  },
}
